import {
  CButton,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import axios from 'axios'
import { Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { URL__API } from 'src/axios'
import DefaultLayout from 'src/layout/DefaultLayout'
import { PropTypes } from 'prop-types'
import * as Yup from 'yup'

const AddUsers = ({ history }) => {
  const [visible, setVisible] = useState(false)

  const register = async ({ firstname, lastname, password, email, phone, role = '2' }) => {
    try {
      setVisible(true)
      if (visible) {
        const res = await axios.post(`${URL__API}/user/register`, {
          firstname,
          lastname,
          email,
          password,
          phone,
          role,
        })

        if ([200, 201].includes(res.status)) {
          setVisible(false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const validationSchema = Yup.object().shape({
    firstname: Yup.string().required('Veuillez renseigner ce champ'),
    lastname: Yup.string().required('Veuillez renseigner ce champ'),
    password: Yup.string().required('Veuillez renseigner ce champ'),
    email: Yup.string().email("Format d'email invalide").required('Veuillez renseigner ce champ'),
    phone: Yup.string().required('Veuillez renseigner ce champ'),
  })

  return (
    <DefaultLayout>
      <div className="">
        <Formik
          validationSchema={validationSchema}
          initialValues={{
            firstname: '',
            lastname: '',
            password: '',
            email: '',
            phone: '',
          }}
          onSubmit={register}
        >
          {({ values, touched, errors, handleChange, handleSubmit }) => (
            <CForm className="w-75 mt-5 mx-auto" onSubmit={handleSubmit}>
              <CModal alignment="center" visible={visible} onClose={() => setVisible(false)}>
                <CModalHeader>
                  <CModalTitle>Ajouter</CModalTitle>
                </CModalHeader>
                <CModalBody>Etes-vous sûr d&apos;ajouter cet user ?</CModalBody>
                <CModalFooter>
                  <CButton color="danger" onClick={() => setVisible(false)}>
                    Non
                  </CButton>
                  <CButton color="success" onClick={() => register(values)}>
                    Oui
                  </CButton>
                </CModalFooter>
              </CModal>
              <CRow className="new__user">
                <CCol xs className="col_user">
                  <CFormLabel>Nom</CFormLabel>
                  <CFormInput
                    placeholder="Nom"
                    type="text"
                    name="firstname"
                    value={values.firstname}
                    onChange={handleChange}
                  />
                  {errors.firstname && touched.firstname && (
                    <p style={{ color: 'red' }}>{errors.firstname}</p>
                  )}
                </CCol>
                <CCol xs className="col_user">
                  <CFormLabel>Prénom</CFormLabel>
                  <CFormInput
                    placeholder="Prénom"
                    type="text"
                    name="lastname"
                    value={values.lastname}
                    onChange={handleChange}
                  />
                  {errors.lastname && touched.lastname && (
                    <p style={{ color: 'red' }}>{errors.lastname}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="new__user">
                <CCol xs className="col_user">
                  <CFormLabel>Mot de passe</CFormLabel>
                  <CFormInput
                    placeholder="Mot de passe"
                    type="password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                  />
                  {errors.password && touched.password && (
                    <p style={{ color: 'red' }}>{errors.password}</p>
                  )}
                </CCol>
              </CRow>
              <CRow className="new__user">
                <CCol xs className="col_user">
                  <CFormLabel>Email</CFormLabel>
                  <CFormInput
                    placeholder="Email"
                    type="email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                  />
                  {errors.email && touched.email && <p style={{ color: 'red' }}>{errors.email}</p>}
                </CCol>
                <CCol xs className="col_user">
                  <CFormLabel>Téléphone</CFormLabel>
                  <CFormInput
                    placeholder="Téléphone"
                    type="text"
                    name="phone"
                    value={values.phone}
                    onChange={handleChange}
                  />
                  {errors.phone && touched.phone && <p style={{ color: 'red' }}>{errors.phone}</p>}
                </CCol>
              </CRow>

              <CRow className="mt-5 w-100">
                <CCol xs>
                  <CButton
                    type="submit"
                    style={{
                      color: 'white',
                      background: '#2ACC96',
                      border: '#2ACC96',
                      textDecoration: 'none',
                    }}
                    className="w-100 py-2"
                  >
                    Ajouter
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
          )}
        </Formik>
      </div>
    </DefaultLayout>
  )
}

AddUsers.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
}

export default AddUsers
